import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, Resolve, Router, RouterStateSnapshot } from "@angular/router";
import IProjectsResolver from "@models/IProjectsResolver.models";
import { DevelopmentService } from "@services/development.service";
import { ProjectService } from "@services/project.service";
import { Observable, of } from "rxjs";

@Injectable({
  providedIn: "root",
})
export class ProjectsResolver implements Resolve<IProjectsResolver> {
  constructor(
    public router: Router,
    public projectService: ProjectService,
    public developmentService: DevelopmentService,
  ) {}

  resolve(
    route: ActivatedRouteSnapshot,
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    state: RouterStateSnapshot,
  ): Observable<IProjectsResolver> | Promise<IProjectsResolver> {

    const project = this.projectService
      .getItems()
      .filter((item) => item.id == route.params["itemId"])[0];

    const development = this.developmentService
      .getItems()
      .filter((item) => item.id == route.params["developmentId"])[0];

    return of({ project, development });
  }
}
